import { useState } from 'react';
import StudentDirectory from './StudentDirectory';
import InstructorPerformance from './InstructorPerformance';

// The staff student area: the roster itself, and how each instructor's students
// are doing. Same segmented control as the attendance screen, so the two admin
// sections behave alike.

const MODES = [
  { id: 'directory', label: 'Students' },
  { id: 'instructors', label: 'Instructor performance' },
];

export default function StudentsScreen() {
  const [mode, setMode] = useState('directory');

  return (
    <div>
      <div className="mx-auto mb-4 flex max-w-5xl">
        <div className="inline-flex gap-1 rounded-lg bg-gray-100 p-1">
          {MODES.map((option) => (
            <button
              key={option.id}
              onClick={() => setMode(option.id)}
              className={`rounded-md px-4 py-1.5 text-sm font-medium transition-colors ${
                mode === option.id ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>

      {mode === 'directory' ? <StudentDirectory /> : <InstructorPerformance />}
    </div>
  );
}
